import clsx from "clsx";
import type { ReactNode } from "react";
import CloseButton from "./CloseButton";
import ErrorCloseButton from "./ErrorCloseButton";

export default function HeaderWrapper({
  padded,
  bottomBorder,
  leftSlot,
  leftSlotGap,
  rightSlot,
  messengerId,
  closeButtonNudgeRight,
  conversationId,
  isErrorHeader,
}: {
  padded?: boolean;
  bottomBorder?: boolean;
  leftSlot?: ReactNode;
  leftSlotGap?: boolean;
  rightSlot?: ReactNode;
  messengerId?: string;
  closeButtonNudgeRight?: boolean;
  conversationId?: string;
  isErrorHeader?: boolean;
}) {
  return (
    <div
      className={clsx(
        "header relative flex h-[60px] shrink-0 items-center justify-between",
        "text-[--contrastText]",
        "bg-[--color500] dark:bg-[--color500]",
        padded ? "px-5" : "px-1",
        bottomBorder && "border-b border-[--color600] dark:border-[--color600]",
        "rounded-t-[inherit]",
      )}
    >
      <div className={clsx("flex min-w-0 items-center", leftSlotGap && "gap-2")}>{leftSlot}</div>
      <div className="flex items-center gap-2">{rightSlot}</div>
      {isErrorHeader ? (
        <ErrorCloseButton messengerId={messengerId} />
      ) : (
        <CloseButton
          messengerId={messengerId}
          nudgeRight={closeButtonNudgeRight}
          conversationId={conversationId}
        />
      )}
    </div>
  );
}
